import { render, staticRenderFns } from "./TextRecipients.vue?vue&type=template&id=a5327f00&scoped=true&lang=pug"
import script from "./TextRecipients.vue?vue&type=script&lang=js"
export * from "./TextRecipients.vue?vue&type=script&lang=js"
import style0 from "./TextRecipients.vue?vue&type=style&index=0&id=a5327f00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5327f00",
  null
  
)

export default component.exports